<button mat-stroked-button type="button" (click)="velgFil()" [disabled]="velgBildeKnappDeaktivert()" data-testid="velg-bilde">
  <ng-content>{{ 'Velg bilde'|translate }}</ng-content>
</button>
@if (bildeForStor()) {
  <p class="valideringsfeil">
    <i class="ion-alert-circled"></i>
    {{ 'Bildet kan ikke være større enn {maks}'|translate : {maks: maksStoerrelse()|filstoerrelse} }}
  </p>
}
